import { fileExtensionForType, fileURLFromJSONValue } from './parser'

export type IncidentPostData = {
  id?: string
  incidentID: string
  message: string
  attachments: AttachmentData[]
  imagesToAdd: string[]
}

export type AttachmentData = {
  File: string
  Name: string
  Type: string
  Refresh: number
  Width: number
  Height: number
}

export const attachmentURL = (file: string, type: string, width: number = 0, height: number = 0) => {
  if (file.startsWith('https://')) {
    return file
  }
  let url = `${process.env.REACT_APP_API_URL}/v1/${fileURLFromJSONValue(file, fileExtensionForType(type))}`
  if (width > 0 && height > 0) {
    url += `?x=${width}&y=${height}`
  } else if (width > 0) {
    url += `?x=${width}`
  } else if (height > 0) {
    url += `?y=${height}`
  }
  return url
}

export const isImageAttachment = (attachment: AttachmentData) => {
  return attachment.Type === 'image/png' || attachment.Type === 'image/jpeg'
}
